export default __webpack_public_path__ + "static/media/1791.4c952cfa.png";